<template>
    <div>
        <div class="card-line-header">
            <router-link :to="{ path:'/eventUpdata', query: { serialNumber: detail.serialNumber, callback: callback } }">
                <el-button type="primary">新增配置关系</el-button>
            </router-link>
            <router-link :to="{ path: '/topologicalGraph',
                                        query: { serialNumber:detail.serialNumber }}">
                <el-button type="primary">配置项拓扑图</el-button>
            </router-link>
        </div>
        <el-table :data="detail.toCmdb">
            <el-table-column label="From">
                <el-table-column label="名称" prop="from_title"></el-table-column>
                <el-table-column label="分类" prop="from_category"></el-table-column>
                <el-table-column label="状态" prop="from_status">
                    <template slot-scope="scope">
                        {{ scope.row.from_status | tableVal(cmdbStatus) }}
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="To">
                <el-table-column label="名称" prop="to_title"></el-table-column>
                <el-table-column label="分类" prop="to_category"></el-table-column>
                <el-table-column label="状态" prop="to_status">
                    <template slot-scope="scope">
                        {{ scope.row.to_status | tableVal(cmdbStatus) }}
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="关系类型" prop="relationship">
                <template slot-scope='scope'>
                    {{ scope.row.relationship | tableVal(cmdbRelationshipType) }}
                </template>
            </el-table-column>
            <el-table-column label="描述" prop="description"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope='scope'>
                    <el-button
                            class="table-del-btn"
                            @click.native.prevent="deleteRow(scope.$index, detail.toCmdb, scope.row)"
                            type="text"
                            plain
                    >删除</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>    
import services from './configuration.services.js'
export default {

    props:{
        detail:Object,
        callback: Function
    },

    computed:{

        // 字典
        dictionary(){
            return this.$store.state.dictionary
        },

        // 配置项状态
        cmdbStatus() {
            return this.dictionary.cmdb_status
        },

        // 关系类型
        cmdbRelationshipType() {
            return this.dictionary.cmdb_relationship_type
        }
    },

    methods: {
        // 删除列表某一项
        deleteRow(index, rows, row) {
            this.$confirm("此操作将永久删除该合同, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    let params = {
                        serialNumber: row.from_serialNumber,
                        targetSerialNumber: row.to_serialNumber
                    }
                    services
                        .cmdbRelationshipDelete(params)
                        .then(res => {
                            this.$message.success("删除成功!")
                            rows.splice(index, 1);
                        })
                        .catch(err => this.$message.error(err.message))
                    })
                .catch(() => {
                    this.$message.info("已取消删除")
                })
        }
    }
}
</script>

<style lang="scss" scoped rel="stylesheet/scss">

</style>
